import "./experience.css"
import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Link, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {setExpInfoData} from "../../../redux/experience_store";
import {setPersonalData} from "../../../redux/personal_store";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import apiClient from "../../../utils/axios";
import ProgressBar from "react-bootstrap/ProgressBar";
import personal_img from "../../../assets/pers_img.webp";

function ExperienceInfo({expInfoData, setExpInfoData, appData, account, personalData}) {

    const campaignSlug = window.campaign_slug || ''

    const {t} = useTranslation()
    const navigate = useNavigate()
    const now = 60;

    let linkTo = '/conditions'
    if (appData.account_type === 'joint') linkTo = '/owner-info'
    if (appData.account_type === 'IRA') linkTo = '/ira-account'

    const [expInfoDataErrors, setExpInfoDataErrors] = useState({
        stockYear: '',
        stockAverageSize: '',
        stockAverageNumber: '',
        optionYear: '',
        optionAverageSize: '',
        optionAverageNumber: '',
        invest_obj: '',
    });

    useEffect(() => {
        if (((account.accountType === 'marginAcc' && account.selectedOption === 'level1') ||
            (account.accountType === 'marginAcc' && account.selectedOption === 'level0') ||
            (account.selectedOption !== 'level1' && account.selectedOption !== 'level0'))) {
            handleInputChange({target: {name: 'investmentObjective', value: 'D', type: 'radio', checked: true}})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setExpInfoData({
            stockYear: '1-2',
            stockAverageSize: '100-500',
            stockAverageNumber: '1-50',
            optionYear: '1-2',
            optionAverageSize: '1-10',
            optionAverageNumber: '1-50',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setExpInfoDataErrors({
            stockYear: '',
            stockAverageSize: '',
            stockAverageNumber: '',
            optionYear: '',
            optionAverageSize: '',
            optionAverageNumber: '',
        });

        let isValid = true;

        if (!expInfoData.stockYear) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockYear: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.stockAverageSize) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockAverageSize: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.stockAverageNumber) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockAverageNumber: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.optionYear) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionYear: t('errors.required_field'),
            }));
            isValid = false;
        } else if (expInfoData.optionYear === '0' && campaignSlug === '42343') {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionYear: "Option experience is too low for this account",
            }));
            isValid = false;
        }

        if (!expInfoData.optionAverageSize) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageSize: t('errors.required_field'),
            }));
            isValid = false;
        } else if (expInfoData.optionAverageSize === '0' && campaignSlug === '42343') {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageSize: "Option experience is too low for this account",
            }));
            isValid = false;
        }

        if (!expInfoData.optionAverageNumber) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageNumber: t('errors.required_field'),
            }));
            isValid = false;
        } else if (expInfoData.optionAverageNumber === '0' && campaignSlug === '42343') {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageNumber: "Option experience is too low for this account",
            }));
            isValid = false;
        }

        if (isValid) {
            setExpInfoData(expInfoData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await updateExpValues()
                navigate(linkTo)
            } catch (error) {
                setExpInfoDataErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;

        if (type === "checkbox") {
            setExpInfoData({...expInfoData, [name]: checked});
        } else if (type === "radio" && name === "investmentObjective") {
            setExpInfoData({...expInfoData, invest_obj: value});
        } else {
            setExpInfoData({...expInfoData, [name]: value});
        }
    };

    const getExpValues = () => {
        return {
            accountType: account.accountType,
            dayTrade: account.dayTrade,
            OptionTradeLevel: account.selectedOption,
            StockYearsExp: expInfoData.stockYear,
            StockAvgSize: expInfoData.stockAverageSize,
            StockAvgTrans: expInfoData.stockAverageNumber,
            OptionYears: expInfoData.optionYear,
            OptionSize: expInfoData.optionAverageSize,
            OptionAvgTrans: expInfoData.optionAverageNumber,
            InvestmentObj: expInfoData.invest_obj,
        }
    };

    const updateExpValues = async () => {
        try {
            const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step4/` + appData.app_id;
            const params = getExpValues();

            const response = await apiClient.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={personal_img} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>

                <div>
                    <p className="experience_heading text-center font-normal text-xl mt-3">
                        {t('experience.welcome')} {personalData.firstName} {personalData.lastName}. {t('experience.investment_experience')}
                    </p>
                    <p className="exp_investment_text text-center font-normal text-lg">{t('experience.previous_investment')} </p>
                    <form onSubmit={handleSubmit}>
                        <div
                            className="flex align-items-center sm:justify-content-evenly justify-content-start pb-5 gap-3 sm:flex-row flex-column">
                            <span className="exp_stocks_text font-bold text-xl">{t('experience.stocks')}</span>

                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="stockYear"
                                             value={expInfoData.stockYear}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.year')}</option>
                                    <option value="1-2">1-2</option>
                                    <option value="3-5">3-5</option>
                                    <option value="6-10">6-10</option>
                                    <option value="10+">10+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockYear &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockYear}</p>}
                            </div>
                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="stockAverageSize"
                                             value={expInfoData.stockAverageSize}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.average_size')}</option>
                                    <option value="100-500">100-500</option>
                                    <option value="501-1000">501-1000</option>
                                    <option value="1001-5000">1001-5000</option>
                                    <option value="5000+">5000+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockAverageSize &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockAverageSize}</p>}
                            </div>

                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="stockAverageNumber"
                                             value={expInfoData.stockAverageNumber}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.average_number')}</option>
                                    <option value="1-50">1-50</option>
                                    <option value="51-100">51-100</option>
                                    <option value="101-500">101-500</option>
                                    <option value="501+">501+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockAverageNumber &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockAverageNumber}</p>}
                            </div>
                        </div>

                        <div
                            className="flex align-items-center sm:justify-content-evenly justify-content-start pb-5 gap-3 sm:flex-row flex-column">
                            <span className="exp_options_text font-bold text-xl">{t('experience.options')}</span>
                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="optionYear"
                                             value={expInfoData.optionYear}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.year')}</option>
                                    <option value="0">0</option>
                                    <option value="1-2">1-2</option>
                                    <option value="3-5">3-5</option>
                                    <option value="6-10">6-10</option>
                                    <option value="10+">10+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionYear &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionYear}</p>}
                            </div>

                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="optionAverageSize"
                                             value={expInfoData.optionAverageSize}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.average_size')}</option>
                                    <option value="0">0</option>
                                    <option value="1-10">1-10</option>
                                    <option value="11-20">11-20</option>
                                    <option value="21-100">21-100</option>
                                    <option value="101+">101+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionAverageSize &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionAverageSize}</p>}
                            </div>
                            <div className="md:w-2 w-full">
                                <Form.Select aria-label="Default select example"
                                             className="exp_form flex align-items-center p-1 pl-2 w-full"
                                             name="optionAverageNumber"
                                             value={expInfoData.optionAverageNumber}
                                             onChange={handleInputChange}>
                                    <option value="" disabled>{t('experience.average_number')}</option>
                                    <option value="0">0</option>
                                    <option value="1-50">1-50</option>
                                    <option value="51-100">51-100</option>
                                    <option value="101-500">101-500</option>
                                    <option value="501+">501+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionAverageNumber &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionAverageNumber}</p>}
                            </div>
                        </div>
                        <p className="exp_investment_obj text-center font-normal pt-4 text-lg">
                            {t('experience.investment_objective')}
                        </p>
                        <p className="exp_investment_obj_text text-center font-bold text-base m-auto lg:w-10 w-full">
                            {t('experience.speculative_activity')}
                        </p>
                        <p className="exp_objs text-center font-normal pt-4 text-lg">{t('experience.objective')}</p>
                        <div className="flex align-items-center w-full m-auto gap-2">
                            <input
                                type="radio"
                                value="B"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'B'}
                                onChange={handleInputChange}
                                disabled={
                                    (account.accountType === 'marginAcc' && account.selectedOption === 'level1') ||
                                    (account.accountType === 'marginAcc' && account.selectedOption === 'level0') ||
                                    (account.selectedOption !== 'level1' && account.selectedOption !== 'level0')
                                }
                            />
                            <p className="checkbox_text sm:text-lg text-base text-justify">{t('experience.risk_tolerance')}</p>
                        </div>
                        <div className="flex align-items-center w-full m-auto gap-2">
                            <input
                                type="radio"
                                value="C"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'C'}
                                onChange={handleInputChange}
                                disabled={
                                    account.selectedOption !== 'level1' &&
                                    account.selectedOption !== 'level0'
                                }
                            />
                            <p className="checkbox_text sm:text-lg text-base text-justify">
                                {t('experience.capital_appreciation')}
                            </p>
                        </div>
                        <div className="flex align-items-center w-full m-auto gap-2">
                            <input
                                type="radio"
                                value="D"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'D'}
                                onChange={handleInputChange}
                            />
                            <p className="checkbox_text sm:text-lg text-base text-justify">{t('experience.time_horizon')}</p>
                        </div>

                        <div
                            className="w-10 flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column row-gap-3 pt-6 m-auto">
                            <Link className="no-underline" to="/account">
                                <button className="back_btn">{t('back_btn')}</button>
                            </Link>
                            <button className="continue_btn" type="submit">{t('next_btn')}</button>
                        </div>
                        <div>
                            {expInfoDataErrors.submitError && (
                                <div className="text-red-500 text-center">
                                    {expInfoDataErrors.submitError}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    expInfoData: state.expInfoData,
    account: state.account,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setExpInfoData,
    setPersonalData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceInfo);